export default function LoadIcon() {
  return (
    <div className="spinner-border text-primary mt-2" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  );
}
